import { Reveal } from "./Reveal";
import { WEBINAR_STEPS } from "@/data/content";
import { CTAButton } from "./CTAButton";

export const WebinarSteps = () => {
  return (
    <section id="ablauf-webinar" data-testid="webinar-steps" className="relative py-24 sm:py-32">
      <div className="absolute inset-x-0 top-1/2 -z-10 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
      <div className="mx-auto max-w-6xl px-5 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <Reveal>
            <span className="font-heading text-xs font-semibold uppercase tracking-[0.24em] text-brand-blue">
              So läuft das Webinar ab
            </span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-heading text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl">
              In wenigen Sekunden <span className="text-gradient-brand">bist du dabei.</span>
            </h2>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-3">
          {WEBINAR_STEPS.map((s, i) => (
            <Reveal key={s.num} delay={i * 0.12}>
              <div className="relative flex h-full flex-col items-center rounded-2xl border border-white/10 bg-brand-surface px-6 py-10 text-center transition-colors duration-300 hover:border-brand-green/40">
                <div className="relative flex h-16 w-16 items-center justify-center rounded-full bg-brand-green text-brand-bg glow-green-sm">
                  <s.icon className="h-7 w-7" />
                  <span className="absolute -right-1 -top-1 flex h-7 w-7 items-center justify-center rounded-full border border-white/10 bg-brand-bg font-heading text-sm font-bold text-brand-green">
                    {s.num}
                  </span>
                </div>
                <h3 className="mt-6 font-heading text-xl font-bold text-white">{s.title}</h3>
                <p className="mt-3 font-body text-sm leading-relaxed text-white/60">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <div className="mt-14 flex justify-center">
            <CTAButton testId="steps-cta">Kostenlosen Webinar-Platz sichern</CTAButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
